// The only roles this app has routes for. App.tsx mounts /student, /teacher and
// /parent subtrees and nothing else.
//
// Why this needs to be explicit: both post-login redirects used to interpolate
// the role straight into a path (`/${role}`). Any other value — 'advisor' is a
// real role in the `roles` table, and the estate keeps adding them — routed to a
// path with no <Route>, i.e. a blank screen with no error and no way back. That
// was survivable while the password form was the main door and the account
// creating those sessions was local. It is not survivable now that Birey Kimlik
// is the only advertised door: the role arrives from an identity system this app
// does not control, so an unroutable one is a normal event, not a bug.
//
// birey.routes.ts already refuses role==='admin' at the callback with
// use_admin_login, so admin never reaches here. 'advisor' does.
export const APP_ROLES = ['student', 'teacher', 'parent'] as const

export type AppRole = (typeof APP_ROLES)[number]

export function isAppRole(role: string | null | undefined): role is AppRole {
  return !!role && (APP_ROLES as readonly string[]).includes(role)
}

/**
 * Where a freshly-authenticated session should land. Returns the login page with
 * a renderable reason instead of a dead path when the role has no subtree.
 */
export function roleLandingPath(role: string | null | undefined): string {
  return isAppRole(role) ? `/${role}` : '/login?birey_error=unsupported_role'
}
